import {
  Button,
  Dropdown,
  List,
  Modal,
  notification,
  Spin,
  Avatar,
} from "antd";
import Picker from "emoji-picker-react";
import { serverTimestamp } from "firebase/firestore";
import React, {
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import { FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { Assets } from "../../../constants/images";
import moment from "moment";
import AddPeopleSelector from "../../Common/AddPeopleSelector";
import {
  BinocularsLight,
  MoreIcon,
  RecycleBin,
  SendButtonTriangle,
  ToastCrossIcon,
  AtRegularIcon,
  CirclePlusIcon,
  FaceSmileyIcon,
  BlackStarIcon,
  ReplyIcon,
} from "../../../constants/svg";
import {
  deleteThread,
  getChannelMessages,
  loadOlderMessages,
  sendMessage,
  deleteMessage,
  updateMessage,
  isChatUserDeleted,
  calculateSeenMembers,
  toggleStarChat,
} from "../../../services/chats/frontend-chats";
import { GetAuthUserLocalStorage } from "../../../services/localStorage/localStorage";
import {
  classifyChatFile,
  getActiveMemberCount,
  getChatSendButtonClass,
  personalizeGroupNameForReceiver,
  shouldUsePdfThumbnailUpload,
} from "../../../utils/chatUtils";
import {
  message_type,
  roles as salonRoles,
  pdf_field_names,
  media_collection_field_names,
} from "../../../utils/constants";
import { ReactionUserList } from "./Reactions";
import SeenByModal from "./Reactions/SeenByModal";
import {
  blobToFile,
  renderContentWithMentions,
  salonUploadToS3,
  toastMessage,
  uploadPdfWithThumbnail,
  uploadMediaCollection,
  generateVideoThumbnail,
  uploadVideoThumbnail,
  getAttachmentPreviewText,
  getMediaCollectionPreviewText,
  isValidUrl,
} from "../../../utils/helper";
import NewChat from "./NewChat";
import MessageBubble from "./MessageBubble";
import DeleteModal from "../../Modals/DeleteModal";
import LoadingScreen from "../../LoadingScreen/LoadingScreen";
import PdfMessage from "./PdfMessage";
import MediaCollectionMessage from "./MediaCollectionMessage";
import MediaCollectionPreview from "./MediaCollectionPreview";
import AvatarImage from "../../Common/AvatarImage";
import { find, head, toString } from "lodash";
import {
  setSelectedUser,
  selectOptimisticChannelMessages,
} from "../../../store/slices/chatsSlice";
import store from "../../../store/store";
import EveryOneImage from "../../../assets/images/everyone.svg";
import TextArea from "antd/es/input/TextArea";
import FileIcon from "./FileIcon";

const actionMenu = (
  user,
  setConfirmDeleteChatPopup,
  channelMessages,
  authUserId,
  handleStarToggle,
) => {
  const isStarred = user?.users_who_pinned_chat?.includes(authUserId) || false;
  const isEveryoneGroup = user?.is_everyone_group === true;

  const menuItems = [
    {
      key: uuidv4(),
      label: (
        <>
          {Object.keys(user).length > 0 && (
            <NavLink
              to={`${user?.is_group_chat ? `/team/groups/${user?.group_id}` : `/team/members/${user?.receiver_profile?.[0]?.id}`}`}
              onClick={(e) => {
                if (
                  user.is_user_group ||
                  user?.receiver_profile?.[0]?.is_deleted
                ) {
                  e.preventDefault();
                }
              }}
              className={"black"}
              disabled={
                user.is_user_group || user?.receiver_profile?.[0]?.is_deleted
              }
            >
              <BinocularsLight />
              View Profile
            </NavLink>
          )}
        </>
      ),
    },
    {
      key: uuidv4(),
      label: (
        <div
          className={"black"}
          onClick={() => {
            if (handleStarToggle && user?.chat_id) {
              handleStarToggle(user.chat_id);
            }
          }}
          style={{ cursor: "pointer" }}
        >
          <BlackStarIcon fill="gold" />
          {isStarred ? "Unstar Chat" : "Star Chat"}
        </div>
      ),
    },
    /*    {
          key: uuidv4(),
          className: user?.is_group_chat ? "d-none" : "d-block",
          label: (
            <>
              {
                user?.is_group_chat ?
                  <></>
                    : null
                 /!* <NavLink to="/team/groups" className={"black"}>
                    <div className="d-flex align-items-center w-100">
                      <PlusIconLight />
                      Add to group
                    </div>
                  </NavLink>*!/
              }
            </>
          ),
        }, */
  ];

  // Only add "Delete Thread" option if it's not an Everyone group chat
  if (!isEveryoneGroup) {
    menuItems.push({
      key: uuidv4(),
      label: (
        <div
          className={"deleteLabel"}
          onClick={() => {
            setConfirmDeleteChatPopup(true);
          }}
        >
          <RecycleBin />
          Delete Thread
        </div>
      ),
    });
  }

  return menuItems;
};

// Finds the topmost message element whose bottom is within the visible
// viewport of the scroll container. Used as the anchor when prepending older
// messages so the user's view stays locked on a real DOM element.
const findTopmostVisibleMessage = (container) => {
  if (!container) return null;
  const containerTop = container.getBoundingClientRect().top;
  const items = container.querySelectorAll("[data-thread-id]");
  for (let i = 0; i < items.length; i += 1) {
    const rect = items[i].getBoundingClientRect();
    if (rect.bottom > containerTop + 1) {
      return items[i];
    }
  }
  return null;
};

const ChatWindowV2 = (props) => {
  const [message, setMessage] = useState("");
  const messagesEndRef = useRef(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const authUser = GetAuthUserLocalStorage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pickerRef = useRef();
  const { me } = useSelector((state) => state.auth);
  const { currentSalonId } = useSelector((state) => state.global);
  const inputRef = useRef(null);
  const fileInputRef = useRef(null);
  const composerRef = useRef(null);
  const [composerHeight, setComposerHeight] = useState(0);
  const [listHeight, setListHeight] = useState("calc(100vh - 295px)");
  const isUserNearBottomRef = useRef(true);
  // Scroll-anchor preservation for lazy-loading older messages. We anchor on
  // a specific message element (by thread_id) rather than on scrollHeight
  // deltas so variable-height content (images loading, reactions, etc.)
  // cannot shift the user's viewport.
  const prevFirstThreadIdRef = useRef(null);
  const anchorThreadIdRef = useRef(null);
  const anchorOffsetFromTopRef = useRef(0);
  // Tracks the first thread_id seen by the near-bottom auto-scroll effect so
  // it can identify a prepend render and skip scrolling to bottom.
  const lastKnownFirstThreadIdRef = useRef(null);
  const SCROLL_UP_THRESHOLD_PX = 80;
  const { selectedUser, userListing } = useSelector((state) => state?.chats);
  const { allUsers } = useSelector((state) => state?.chats);
  const channelMessages = useSelector(selectOptimisticChannelMessages);
  const hasSelectedUser = useMemo(
    () => Object.keys(selectedUser || {}).length > 0,
    [selectedUser],
  );

  const findChatUser = useCallback(
    (userId) => {
      const users = userListing?.data;
      return find(
        users,
        ({ receiver_profile, is_group_chat }) =>
          !is_group_chat && head(receiver_profile)?.id === `${userId}`,
      );
    },
    [userListing?.data],
  );
  const handleItemClick = useCallback(
    (user) => {
      dispatch(setSelectedUser(user));
    },
    [dispatch],
  );

  const handleUsernameClick = useCallback(
    (e, senderId) => {
      e.preventDefault();
      e.stopPropagation();

      if (senderId == authUser?.id) {
        navigate(`/settings/profile`);
      } else if (selectedUser?.is_group_chat) {
        const senderProfile = selectedUser?.receiver_profile?.find(
          (profile) => profile.id == senderId,
        );

        if (senderProfile && !senderProfile.is_deleted) {
          navigate(`/team/members/${senderProfile.id}`);
        }
      } else {
        const otherUser = selectedUser?.receiver_profile?.[0];
        if (otherUser && !otherUser.is_deleted) {
          navigate(`/team/members/${otherUser.id}`);
        }
      }
    },
    [authUser?.id, selectedUser, navigate],
  );

  const handleMentionClick = useCallback(
    (mentionUserId) => {
      if (mentionUserId == authUser?.id) {
        navigate(`/settings/profile`);
      } else if (selectedUser?.is_group_chat) {
        const mentionedProfile = selectedUser?.receiver_profile?.find(
          (profile) => profile.id == mentionUserId,
        );

        if (mentionedProfile && !mentionedProfile.is_deleted) {
          navigate(`/team/members/${mentionedProfile.id}`);
        }
      } else {
        const otherUser = selectedUser?.receiver_profile?.[0];
        if (
          otherUser &&
          !otherUser.is_deleted &&
          otherUser.id == mentionUserId
        ) {
          navigate(`/team/members/${otherUser.id}`);
        }
      }
    },
    [authUser?.id, selectedUser, navigate],
  );
  const [onDelete, setOnDelete] = useState(1);
  const [file, setFile] = useState([]);
  const [selectedMediaCollection, setSelectedMediaCollection] = useState([]);
  const [showMediaPreview, setShowMediaPreview] = useState(false);
  const [confirmDeleteChatPopup, setConfirmDeleteChatPopup] = useState(false);
  const mediaRecorder = useRef(null);
  const audioChunksRef = useRef([]);
  const mediaStreamRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const waveformRafRef = useRef(null);
  const waveformAmplitudeRef = useRef(0.12);
  const [isRecording, setIsRecording] = useState(false);
  const [voiceMemoPreview, setVoiceMemoPreview] = useState(null);
  const [waveformBars, setWaveformBars] = useState([]);
  const [timer, setTimer] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [disable, setDisable] = useState(false);
  const [disableSendChatBtn, setDisableSendChatBtn] = useState(false);
  const [editingMessage, setEditingMessage] = useState(null); // Track which message is being edited
  const [replyingToMessage, setReplyingToMessage] = useState(null); // Track which message is being replied to

  const [isOpenPreview, setIsOpenPreview] = useState(false);
  const [srcPreview, setSrcPreview] = useState("");

  // Reaction state (hover picker state now lives inside MessageBubble)
  const [showReactionUsers, setShowReactionUsers] = useState(false);
  const [reactionUsersData, setReactionUsersData] = useState({
    emoji: "",
    users: [],
    messageId: "",
  });

  // Seen By Modal state
  const [showSeenByModal, setShowSeenByModal] = useState(false);
  const [seenByMessage, setSeenByMessage] = useState(null);

  // Mentions dropdown and highlighting state
  const [mentionOpen, setMentionOpen] = useState(false);
  const [mentionQuery, setMentionQuery] = useState("");
  const [mentionIndex, setMentionIndex] = useState(0);

  // Overlay typography sync with TextArea to keep caret aligned
  const [overlayTextMetrics, setOverlayTextMetrics] = useState({
    padding: "6px 1px",
    fontSize: undefined,
    fontFamily: undefined,
    fontWeight: undefined,
    lineHeight: undefined,
    letterSpacing: undefined,
  });
  useEffect(() => {
    const el =
      inputRef.current?.resizableTextArea?.textArea || inputRef.current;
    if (!el || typeof window === "undefined") return;
    const cs = window.getComputedStyle(el);
    setOverlayTextMetrics({
      padding: `${cs.paddingTop} ${cs.paddingRight} ${cs.paddingBottom} ${cs.paddingLeft}`,
      fontSize: cs.fontSize,
      fontFamily: cs.fontFamily,
      fontWeight: cs.fontWeight,
      lineHeight: cs.lineHeight,
      letterSpacing: cs.letterSpacing,
    });
  }, [inputRef]);

  // Build mentions map: { userId: username }
  const mentionUsersMap = useMemo(() => {
    const map = {};
    if (!selectedUser || Object.keys(selectedUser).length === 0) return map;

    if (selectedUser.is_group_chat) {
      const profiles = selectedUser.receiver_profile || [];
      profiles.forEach((p) => {
        if (p && p.id && p.name) {
          map[`${p.id}`] = p.name;
        }
      });
      if (authUser?.id && authUser?.name) {
        map[`${authUser.id}`] = authUser.name;
      }
      // For parity with mobile, expose special group token
      map.group = "group";
    } else {
      const other = selectedUser?.receiver_profile?.[0];
      if (other?.id && other?.name) map[`${other.id}`] = other.name;
      if (authUser?.id && authUser?.name) map[`${authUser.id}`] = authUser.name;
    }

    return map;
  }, [selectedUser, authUser]);

  const handleInputChange = (e) => {
    setMessage(e.target.value);

    // Mention trigger detection and query extraction
    const caretPos = e.target.selectionStart;
    const textUntilCaret = e.target.value.slice(0, caretPos);
    const atIndex = textUntilCaret.lastIndexOf("@");
    if (atIndex >= 0) {
      const afterAt = textUntilCaret.slice(atIndex + 1);
      // If the token after @ already contains whitespace, treat as closed
      if (
        /\s/.test(afterAt) ||
        (atIndex > 0 && /\S/.test(textUntilCaret[atIndex - 1]))
      ) {
        setMentionOpen(false);
        setMentionQuery("");
        setMentionIndex(0);
      } else {
        const match = afterAt.match(/^[^\s@]*/);
        const q = match ? match[0] : "";
        setMentionQuery(q);
        setMentionOpen(true);
        setMentionIndex(0);
      }
    } else {
      setMentionOpen(false);
      setMentionQuery("");
      setMentionIndex(0);
    }
  };

  const handleKeyPress = (e) => {
    if (mentionOpen) return;
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const filteredMentions = useMemo(() => {
    const entries = Object.entries(mentionUsersMap);
    const groupEntry = entries.find(([id]) => id === "group");
    const userEntries = entries.filter(
      ([id]) => id !== "group" && `${id}` !== `${authUser?.id}`,
    );

    // Prefer images from selectedUser.receiver_profile
    const profiles = selectedUser?.receiver_profile || [];
    const userById = new Map(profiles.map((p) => [String(p?.id), p]));

    // Enrich with name and image
    let enriched = userEntries.map(([id, name]) => {
      const profile = userById.get(String(id));
      return {
        id: String(id),
        name: name || profile?.name || "",
        image: (profile?.thumbnail ?? profile?.image) || "",
        isGroup: false,
      };
    });

    // Filter by query
    if (mentionQuery) {
      const q = mentionQuery.toLowerCase();
      enriched = enriched.filter((item) =>
        (item.name || "").toLowerCase().includes(q),
      );
    }

    // Append group at the bottom if present and matches query
    if (groupEntry) {
      const groupObj = {
        id: "group",
        name: "group",
        image: EveryOneImage,
        isGroup: true,
      };
      if (!mentionQuery || "group".includes(mentionQuery.toLowerCase())) {
        enriched = [...enriched, groupObj];
      }
    }

    return enriched;
  }, [mentionUsersMap, mentionQuery, selectedUser, authUser]);

  const handleKeyDown = (e) => {
    if (!mentionOpen || filteredMentions.length === 0) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setMentionIndex((i) => (i + 1) % filteredMentions.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setMentionIndex(
        (i) => (i - 1 + filteredMentions.length) % filteredMentions.length,
      );
    } else if (e.key === "Enter") {
      e.preventDefault();
      const selected = filteredMentions[mentionIndex];
      if (selected && selected.id && selected.name) {
        insertMention(selected.id, selected.name);
      }
    } else if (e.key === "Escape") {
      setMentionOpen(false);
    }
  };

  const handleInsertAtShortcut = () => {
    const el =
      inputRef.current?.resizableTextArea?.textArea || inputRef.current;
    if (!el) return;
    const caret = el.selectionStart ?? 0;
    const before = message.slice(0, caret);
    const after = message.slice(caret);
    const next = `${before}@${after}`;
    setMessage(next);
    setTimeout(() => {
      const el2 =
        inputRef.current?.resizableTextArea?.textArea || inputRef.current;
      if (el2) {
        const nextPos = caret + 1;
        el2.focus();
        el2.setSelectionRange(nextPos, nextPos);
      }
      setMentionOpen(true);
      setMentionQuery("");
      setMentionIndex(0);
    }, 0);
  };

  const insertMention = (userId, name) => {
    const el =
      inputRef.current?.resizableTextArea?.textArea || inputRef.current;
    if (!el) return;
    const caretPos = el.selectionStart;
    const textBefore = message.slice(0, caretPos);
    const textAfter = message.slice(caretPos);
    const atIndex = textBefore.lastIndexOf("@");
    if (atIndex < 0) return;
    const beforeAt = textBefore.slice(0, atIndex);
    const newText = `${beforeAt}@${name} ${textAfter}`;
    setMessage(newText);
    setMentionOpen(false);
    setMentionQuery("");
    setMentionIndex(0);
    const newCaret = (beforeAt + "@" + name + " ").length;
    setTimeout(() => {
      const el2 =
        inputRef.current?.resizableTextArea?.textArea || inputRef.current;
      if (el2) {
        el2.focus();
        el2.setSelectionRange(newCaret, newCaret);
      }
    }, 0);
  };

  // Build highlighted HTML for mentions in input (purple color)
  const inputHighlightHtml = useMemo(() => {
    if (!message) return "";
    const text = message;
    const ranges = [];
    const usernames = Object.values(mentionUsersMap)
      .map((n) => (n || "").trim())
      .filter(Boolean)
      .sort((a, b) => b.length - a.length);
    usernames.forEach((username) => {
      const needle = `@${username}`;
      let i = 0;
      while (true) {
        const idx = text.indexOf(needle, i);
        if (idx < 0) break;
        ranges.push([idx, idx + needle.length]);
        i = idx + needle.length;
      }
    });
    if (ranges.length === 0) {
      const esc = (s) =>
        s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      return esc(text).replace(/\n/g, "<br>");
    }
    ranges.sort((a, b) => a[0] - b[0] || b[1] - a[1]);
    const collapsed = [];
    let lastEnd = -1;
    for (const r of ranges) {
      if (r[0] >= lastEnd) {
        collapsed.push(r);
        lastEnd = r[1];
      }
    }
    let html = "";
    let pos = 0;
    const esc = (s) =>
      s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    collapsed.forEach(([s, e]) => {
      if (s > pos) html += esc(text.slice(pos, s)).replace(/\n/g, "<br>");
      const mentionText = esc(text.slice(s, e));
      // Render mention in purple; non-mention text remains transparent in overlay
      html += `<span style="color:#7B68EE">${mentionText}</span>`;
      pos = e;
    });
    if (pos < text.length) html += esc(text.slice(pos)).replace(/\n/g, "<br>");
    return html;
  }, [message, mentionUsersMap]);

  // Build mentions array to send with message
  const buildMentionsForMessage = (text) => {
    const results = [];
    const seen = new Set();
    const addMention = (id, name) => {
      const key = `${id}`;
      if (seen.has(key)) return;
      seen.add(key);
      const numericId = Number.isFinite(Number(id)) ? Number(id) : id;
      results.push({ userId: numericId, text: `@${name}` });
    };
    // group mention
    if (text.includes("@group") && mentionUsersMap.group) {
      // Align with mobile: use 0 for group userId
      results.push({ userId: 0, text: "@group" });
      seen.add("0");
    }
    // user mentions
    Object.entries(mentionUsersMap).forEach(([id, name]) => {
      if (id === "group") return;
      const needle = `@${name}`;
      if (text.includes(needle)) addMention(id, name);
    });
    return results;
  };

  const scrollToBottom = useCallback((smooth = false) => {
    if (!messagesEndRef.current) return;
    const messagesContainer = messagesEndRef.current.closest(".chat-messages");
    if (!messagesContainer) return;

    if (smooth) {
      messagesContainer.scrollTo({
        top: messagesContainer.scrollHeight,
        behavior: "smooth",
      });
    } else {
      // Immediately pin to the bottom (no rAF gap = no visible jump).
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
      // Follow up after layout settles (e.g. day separator CSS margin applies
      // in the next frame) to mop up any remaining delta.
      requestAnimationFrame(() => {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      });
    }
  }, []);

  const handleClickImage = useCallback((src) => {
    setIsOpenPreview(true);
    setSrcPreview(src);
  }, []);

  const handleCancelPreview = () => {
    setIsOpenPreview(false);
  };

  // Reaction handlers (kept stable so memoized MessageBubble avoids re-renders)
  const handleReactionUserClick = useCallback((emoji, users, messageId) => {
    setReactionUsersData({ emoji, users, messageId });
    setShowReactionUsers(true);
  }, []);

  const handleDeleteMessage = useCallback(
    async (message) => {
      try {
        await deleteMessage(message, selectedUser?.chat_id, dispatch);
      } catch (error) {
        console.error("Failed to delete message:", error);
      }
    },
    [selectedUser?.chat_id, dispatch],
  );

  const handleEditMessage = useCallback((message) => {
    setEditingMessage(message);
    setMessage(message.text || "");
    setTimeout(() => {
      const el =
        inputRef.current?.resizableTextArea?.textArea || inputRef.current;
      if (el) {
        el.focus();
      }
    }, 0);
  }, []);

  const handleCancelEdit = () => {
    setEditingMessage(null);
    setMessage("");
  };

  const handleReplyMessage = useCallback((message) => {
    setReplyingToMessage(message);
    setTimeout(() => {
      const el =
        inputRef.current?.resizableTextArea?.textArea || inputRef.current;
      if (el) {
        el.focus();
      }
    }, 0);
  }, []);

  const handleCancelReply = useCallback(() => {
    setReplyingToMessage(null);
  }, []);

  const handleSeenBy = useCallback((message) => {
    setSeenByMessage(message);
    setShowSeenByModal(true);
  }, []);

  const handleMembersUpdate = (addedCount, removedCount) => {
    let message = "";
    if (addedCount > 0 && removedCount > 0) {
      message = `Added ${addedCount} and removed ${removedCount} members`;
    } else if (addedCount > 0) {
      message = `Added ${addedCount} member${addedCount > 1 ? "s" : ""}`;
    } else if (removedCount > 0) {
      message = `Removed ${removedCount} member${removedCount > 1 ? "s" : ""}`;
    } else {
      message = "No changes made";
    }

    notification.success({
      message,
      placement: "bottomRight",
    });
  };

  const handleStarToggle = async (chatId) => {
    if (!chatId || !authUser?.id) return;

    const success = await toggleStarChat(chatId, authUser.id);

    if (success && selectedUser?.chat_id === chatId) {
      // Update selectedUser to reflect the new star status
      const updatedSelectedUser = {
        ...selectedUser,
        users_who_pinned_chat: selectedUser.users_who_pinned_chat || [],
      };

      const isCurrentlyStarred =
        updatedSelectedUser.users_who_pinned_chat.includes(authUser.id);

      if (isCurrentlyStarred) {
        updatedSelectedUser.users_who_pinned_chat =
          updatedSelectedUser.users_who_pinned_chat.filter(
            (id) => id !== authUser.id,
          );
      } else {
        updatedSelectedUser.users_who_pinned_chat = [
          ...updatedSelectedUser.users_who_pinned_chat,
          authUser.id,
        ];
      }

      dispatch(setSelectedUser(updatedSelectedUser));
    }
  };

  const renderMessageContent = useCallback(
    (item) => {
      if (item?.message_type == message_type?.text) {
        return (
          <p className={"m-0"}>
            {renderContentWithMentions(
              item,
              item?.text,
              item?.mentions,
              handleMentionClick,
            )}
          </p>
        );
      } else if (item?.message_type == message_type?.image) {
        const imageSrc = item?.image_url || Assets.GeneralPlaceholder;
        return (
          <img
            style={{
              width: "180px",
              height: "180px",
              borderRadius: "8px",
              objectFit: "cover",
              objectPosition: "top",
              border: "1px solid #eee",
              cursor: "pointer",
              marginTop: "8px",
            }}
            className={"mx-3"}
            src={imageSrc}
            onError={(e) => (e.target.src = Assets.GeneralPlaceholder)}
            alt=""
            onClick={() => handleClickImage(imageSrc)}
          />
        );
      } else if (item?.message_type == message_type?.video) {
        const thumbnailSrc = item?.image_url || Assets.GeneralPlaceholder;
        return (
          <div
            className="video-container mx-3"
            style={{
              width: "300px",
              height: "200px",
              position: "relative",
              cursor: "pointer",
            }}
            onClick={() => {
              Modal.confirm({
                title: null,
                content: (
                  <video
                    style={{ width: "100%", maxHeight: "96vh" }}
                    controls
                    autoPlay
                  >
                    <source src={item?.video_url} />
                  </video>
                ),
                width: "98vw",
                centered: true,
                okButtonProps: { style: { display: "none" } },
                cancelButtonProps: { style: { display: "none" } },
                className: "video-modal",
                maskClosable: true,
                icon: null,
                closable: true,
                closeIcon: (
                  <div
                    style={{
                      position: "absolute",
                      top: "16px",
                      right: "16px",
                      width: "32px",
                      height: "32px",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      zIndex: 1001,
                      color: "black",
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="black"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    </svg>
                  </div>
                ),
              });
            }}
          >
            <img
              src={thumbnailSrc}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "8px",
              }}
              onError={(e) => (e.target.src = Assets.GeneralPlaceholder)}
            />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          </div>
        );
      } else if (item?.message_type == message_type?.gif) {
        const gifSrc =
          item?.gif_url || item?.image_url || Assets.GeneralPlaceholder;
        return (
          <img
            style={{
              width: "180px",
              height: "180px",
              borderRadius: "8px",
              objectFit: "cover",
              objectPosition: "top",
              border: "1px solid #eee",
              cursor: "pointer",
              marginTop: "8px",
            }}
            className={"mx-3"}
            src={gifSrc}
            onError={(e) => (e.target.src = Assets.GeneralPlaceholder)}
            alt="GIF"
            onClick={() => handleClickImage(gifSrc)}
          />
        );
      } else if (
        item?.message_type == message_type?.audio ||
        item?.message_type == message_type?.voice_memo
      ) {
        return (
          <audio
            className={"mx-3"}
            style={{ width: "300px" }}
            src={item?.audio_url}
            controls
          ></audio>
        );
      } else if (item?.message_type == message_type?.pdf) {
        return <PdfMessage message={item} />;
      } else if (item?.message_type == message_type?.media_collection) {
        return <MediaCollectionMessage message={item} />;
      } else if (item?.message_type == message_type?.media) {
        return (
          <a
            href={item?.media_url}
            className={"file-content mx-3"}
            style={{ width: "300px" }}
            target="_blank"
            download
            rel="noreferrer"
          >
            <span className="file-content-icon">
              <FileIcon fileName={item?.name} />
            </span>
            <span className="file-content-name">{item?.name || "File"}</span>
          </a>
        );
      }
    },
    [handleMentionClick, handleClickImage],
  );

  const returnUserDataInGroupChat = useCallback(
    (item) => {
      const sender_id = item?.sender_id;
      if (sender_id == authUser?.id) {
        return {
          name: authUser?.name,
          image: authUser?.thumbnail ?? authUser?.image,
          isDeleted: false,
        };
      }

      const profile = selectedUser.receiver_profile
        ?.filter(Boolean)
        ?.find(({ id }) => id == sender_id);

      const isDeleted = isChatUserDeleted(profile, allUsers?.data ?? []);

      // if (isDeleted) {
      //   return {
      //     name: "DELETED USER",
      //     image: null,
      //     isDeleted: true,
      //   };
      // }

      return {
        name: profile?.name ?? "DELETED USER",
        image: profile?.thumbnail ?? profile?.image,
        isDeleted: profile?.is_deleted,
      };
    },
    [
      authUser?.id,
      authUser?.name,
      authUser?.image,
      selectedUser.receiver_profile,
    ],
  );

  // Precompute per-message day-separator and timestamp metadata in one pass so
  // MessageBubble can receive stable primitive props and memoize correctly.
  // Keyed by thread_id; recomputes only when the data array reference changes.
  const messageMetaById = useMemo(() => {
    const map = new Map();
    const data = channelMessages?.data || [];
    let lastDateLabel = null;
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      const key = item?.thread_id || item?.id;
      if (!key) continue;
      if (!item?.created_at) {
        map.set(key, {
          showDateSeparator: false,
          dateLabel: null,
          messageTimestamp: null,
        });
        continue;
      }
      let date;
      if (typeof item.created_at === "object" && item.created_at?.seconds) {
        date = moment.unix(item.created_at.seconds);
      } else if (typeof item.created_at === "number") {
        date = moment.unix(item.created_at);
      } else {
        date = moment(item.created_at);
      }

      const currentDate = moment();
      const yesterdayDate = moment().subtract(1, "days");
      const messageTimestamp = date.isValid()
        ? date.format("hh:mm A")
        : "Invalid Time";

      let dateLabel;
      if (date.isValid() && date.isSame(currentDate, "day")) {
        dateLabel = "Today";
      } else if (date.isValid() && date.isSame(yesterdayDate, "day")) {
        dateLabel = "Yesterday";
      } else {
        dateLabel = date.isValid()
          ? date.format("MMMM DD, YYYY")
          : "Invalid Date";
      }

      const showDateSeparator = dateLabel !== lastDateLabel;
      if (showDateSeparator) lastDateLabel = dateLabel;
      map.set(key, { showDateSeparator, dateLabel, messageTimestamp });
    }
    return map;
  }, [channelMessages?.data]);

  const renderMessageItem = useCallback(
    (item, index) => {
      const key = item?.thread_id || item?.id;
      const meta = messageMetaById.get(key) || {
        showDateSeparator: false,
        dateLabel: null,
        messageTimestamp: null,
      };
      const isSentByAdmin = item?.sender_id == authUser?.id;
      const userData = returnUserDataInGroupChat(item);
      const isLastItem = index === (channelMessages?.data?.length || 0) - 1;
      const senderId = item?.sender_id;
      const sender = {
        ...userData,
        receiver_profile: [{ ...userData, id: senderId }],
      };
      const senderFullInfo = findChatUser(senderId);

      return (
        <MessageBubble
          item={item}
          isLastItem={isLastItem}
          isGroupChat={Boolean(selectedUser?.is_group_chat)}
          chatId={selectedUser?.chat_id}
          isSentByAdmin={isSentByAdmin}
          showDateSeparator={meta.showDateSeparator}
          dateLabel={meta.dateLabel}
          messageTimestamp={meta.messageTimestamp}
          userData={userData}
          senderFullInfo={senderFullInfo}
          sender={sender}
          authUser={authUser}
          messagesEndRef={messagesEndRef}
          renderMessageContent={renderMessageContent}
          onItemClick={handleItemClick}
          onUsernameClick={handleUsernameClick}
          onReactionUserClick={handleReactionUserClick}
          onDeleteMessage={handleDeleteMessage}
          onEditMessage={handleEditMessage}
          onReply={handleReplyMessage}
          onSeenBy={handleSeenBy}
          scrollToBottom={scrollToBottom}
          isUserNearBottomRef={isUserNearBottomRef}
        />
      );
    },
    [
      messageMetaById,
      channelMessages?.data?.length,
      selectedUser?.is_group_chat,
      selectedUser?.chat_id,
      authUser,
      returnUserDataInGroupChat,
      findChatUser,
      renderMessageContent,
      handleItemClick,
      handleUsernameClick,
      handleReactionUserClick,
      handleDeleteMessage,
      handleEditMessage,
      handleReplyMessage,
      handleSeenBy,
      scrollToBottom,
    ],
  );

  const handleEmojiClick = (emojiData) => {
    setMessage((prevMessage) => prevMessage + emojiData.emoji);
  };

  const categorizeFiles = (files) => {
    const mediaFiles = files.filter(
      (f) => f.type.startsWith("image/") || f.type.startsWith("video/"),
    );
    const otherFiles = files.filter(
      (f) => !f.type.startsWith("image/") && !f.type.startsWith("video/"),
    );

    return {
      mediaCollection: mediaFiles.length > 0 ? mediaFiles : [],
      individualFiles: otherFiles,
    };
  };

  const resetMediaCollection = () => {
    setSelectedMediaCollection([]);
    setShowMediaPreview(false);
  };

  const handleRemoveFromCollection = (index) => {
    const updatedCollection = selectedMediaCollection.filter(
      (_, i) => i !== index,
    );
    if (updatedCollection.length <= 1) {
      resetMediaCollection();
      if (updatedCollection.length === 1) {
        setFile([updatedCollection[0]]);
      }
    } else {
      setSelectedMediaCollection(updatedCollection);
    }
  };

  const buildReplyPayload = useCallback(() => {
    if (!replyingToMessage) return null;
    return {
      message_id: replyingToMessage.thread_id || replyingToMessage.id || "",
      text: replyingToMessage.text || "",
      sender_id: replyingToMessage.sender_id ?? null,
      message_type: replyingToMessage.message_type ?? null,
      image_url: replyingToMessage.image_url || "",
    };
  }, [replyingToMessage]);

  const handleSendMediaCollection = async () => {
    try {
      setDisableSendChatBtn(true);

      const folder = `${
        GetAuthUserLocalStorage()?.salon?.directory_name || "chat"
      }/`;

      const mediaItems = await uploadMediaCollection(
        selectedMediaCollection,
        folder,
        false,
      );

      const mediaCollectionMessage = {
        created_at: serverTimestamp(),
        id: uuidv4(),
        is_read: false,
        sender_id: authUser?.id,
        message_type: message_type.media_collection,
        [media_collection_field_names.items]: mediaItems,
        [media_collection_field_names.count]: mediaItems.length,
        text: getMediaCollectionPreviewText(mediaItems),
      };

      const replyPayload = buildReplyPayload();
      if (replyPayload) {
        mediaCollectionMessage.reply = replyPayload;
      }

      await sendMessage(selectedUser, mediaCollectionMessage);
      setReplyingToMessage(null);
      scrollToBottom();
      resetMediaCollection();
    } catch (error) {
      notification.error({
        description: error.message,
        placement: "bottomRight",
        className: "createdNotification",
        closeIcon: <ToastCrossIcon />,
      });
    } finally {
      setDisableSendChatBtn(false);
    }
  };

  const fetchChannelMessages = useCallback(() => {
    if (!hasSelectedUser) return;
    getChannelMessages(
      selectedUser,
      channelMessages?.subscription,
      dispatch,
      me?.data?.id,
      store.getState,
    );
  }, [
    hasSelectedUser,
    selectedUser,
    channelMessages?.subscription,
    dispatch,
    me?.data?.id,
  ]);
  const resetMessage = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setFile([]);
    setMessage("");
  };

  const uploadFile = async (file) => {
    const category = classifyChatFile(file);
    const folder = `${
      GetAuthUserLocalStorage()?.salon?.directory_name || "chat"
    }/`;
    const isSuperAdmin =
      GetAuthUserLocalStorage().roles[0].id != salonRoles.super_admin;

    if (category === "document") {
      if (shouldUsePdfThumbnailUpload(file)) {
        const pdfResult = await uploadPdfWithThumbnail(file, folder);
        return {
          url: pdfResult.pdfUrl,
          file_type: "document",
          name: pdfResult.fileName,
          thumbnailUrl: pdfResult.thumbnailUrl,
          fileSize: pdfResult.fileSize,
        };
      }

      const salonS3UploadResponse = await salonUploadToS3(
        file,
        folder,
        isSuperAdmin,
        false,
      );
      return {
        url: salonS3UploadResponse.data.location,
        file_type: "document",
        name: file.name,
        thumbnailUrl: null,
        fileSize: file.size,
      };
    }

    const salonS3UploadResponse = await salonUploadToS3(
      file,
      folder,
      isSuperAdmin,
      false,
    );
    if (!salonS3UploadResponse.status) {
      throw new Error(salonS3UploadResponse?.message);
    }

    const url = salonS3UploadResponse?.data?.location;
    let thumbnailUrl = null;

    if (category === "video") {
      try {
        const thumbnailBlob = await generateVideoThumbnail(file);
        thumbnailUrl = await uploadVideoThumbnail(
          thumbnailBlob,
          "images",
          false,
        );
      } catch (error) {
        console.warn("Video thumbnail generation failed:", error);
      }
    }

    const file_type =
      category === "other" ? file?.type?.split("/")[0] : category;

    return {
      url,
      file_type,
      name: file?.name,
      thumbnailUrl,
      fileSize: file?.size,
    };
  };

  const handleSendVoiceMemo = async () => {
    if (!voiceMemoPreview?.file) return;
    try {
      setDisableSendChatBtn(true);
      const data = await uploadFile(voiceMemoPreview.file);
      const replyPayload = buildReplyPayload();
      const newMessage = {
        created_at: serverTimestamp(),
        id: uuidv4(),
        is_read: false,
        sender_id: authUser?.id,
        image_url: "",
        video_url: "",
        media_url: "",
        message_type: message_type.voice_memo,
        audio_url: data?.url,
        text: getAttachmentPreviewText(message_type.voice_memo),
        duration: voiceMemoPreview.duration,
      };
      if (replyPayload) newMessage.reply = replyPayload;
      await sendMessage(selectedUser, newMessage);
      discardVoiceMemo();
      setReplyingToMessage(null);
      scrollToBottom();
    } catch (e) {
      notification.error({
        description: e.message,
        placement: "bottomRight",
        className: "createdNotification",
        closeIcon: <ToastCrossIcon />,
      });
    } finally {
      setDisableSendChatBtn(false);
    }
  };

  const handleSendMessage = async () => {
    if (voiceMemoPreview) {
      await handleSendVoiceMemo();
      return;
    }

    if (showMediaPreview && selectedMediaCollection.length > 0) {
      await handleSendMediaCollection();
      return;
    }

    try {
      setDisableSendChatBtn(true);

      // Handle editing existing message
      if (editingMessage && message) {
        await updateMessage(
          editingMessage,
          selectedUser?.chat_id,
          message,
          dispatch,
        );
        setEditingMessage(null);
        setMessage("");
        setDisableSendChatBtn(false);
        return;
      }

      const replyPayload = buildReplyPayload();

      const newMessageWithTxt = {
        created_at: serverTimestamp(),
        id: uuidv4(),
        is_read: false,
        sender_id: authUser?.id,
        image_url: "",
        video_url: "",
        media_url: "",
        text: "",
      };

      const newMessageWjithAttachment = {
        created_at: serverTimestamp(),
        id: uuidv4(),
        is_read: false,
        sender_id: authUser?.id,
        image_url: "",
        video_url: "",
        media_url: "",
        text: "",
      };

      if (replyPayload) {
        newMessageWithTxt.reply = replyPayload;
        newMessageWjithAttachment.reply = replyPayload;
      }

      if (message) {
        newMessageWithTxt.text = message;
        const mentions = buildMentionsForMessage(message);
        if (mentions.length > 0) newMessageWithTxt.mentions = mentions;
        newMessageWithTxt.message_type = message_type?.text;
        await sendMessage(selectedUser, newMessageWithTxt);
        scrollToBottom();
      }

      if (file?.length) {
        for (let i = 0; i < file.length; i++) {
          const data = await uploadFile(file[i]);
          newMessageWjithAttachment.name = data?.name;
          if (data?.file_type == "image") {
            newMessageWjithAttachment.message_type = message_type?.image;
            newMessageWjithAttachment.image_url = data?.url;
            newMessageWjithAttachment.text = getAttachmentPreviewText(
              message_type?.image,
            );
          } else if (data?.file_type == "gif") {
            newMessageWjithAttachment.message_type = message_type?.gif;
            newMessageWjithAttachment.gif_url = data?.url;
            newMessageWjithAttachment.image_url = data?.url;
            newMessageWjithAttachment.text = getAttachmentPreviewText(
              message_type?.gif,
            );
          } else if (data?.file_type == "audio") {
            newMessageWjithAttachment.message_type = message_type?.audio;
            newMessageWjithAttachment.audio_url = data?.url;
            newMessageWjithAttachment.text = getAttachmentPreviewText(
              message_type?.audio,
            );
          } else if (data?.file_type == "video") {
            newMessageWjithAttachment.message_type = message_type?.video;
            newMessageWjithAttachment.video_url = data?.url;
            newMessageWjithAttachment.image_url = data?.thumbnailUrl;
            newMessageWjithAttachment.text = getAttachmentPreviewText(
              message_type?.video,
            );
          } else if (
            data?.file_type == "pdf" ||
            data?.file_type == "document"
          ) {
            newMessageWjithAttachment.message_type = message_type?.pdf;
            newMessageWjithAttachment[pdf_field_names.url] = data?.url;
            newMessageWjithAttachment[pdf_field_names.thumbnail_url] =
              data?.thumbnailUrl;
            newMessageWjithAttachment[pdf_field_names.file_name] = data?.name;
            newMessageWjithAttachment[pdf_field_names.file_size] =
              data?.fileSize;
            newMessageWjithAttachment.text = getAttachmentPreviewText(
              message_type?.pdf,
            );
          } else {
            newMessageWjithAttachment.message_type = message_type?.media;
            newMessageWjithAttachment.media_url = data?.url;
            newMessageWjithAttachment.text = getAttachmentPreviewText(
              message_type?.media,
            );
          }
          await sendMessage(selectedUser, newMessageWjithAttachment);
          scrollToBottom();
        }
      }
      setReplyingToMessage(null);
      setDisableSendChatBtn(false);
      resetMessage();
    } catch (e) {
      setDisableSendChatBtn(false);
      notification.error({
        description: e.message,
        placement: "bottomRight",
        className: "createdNotification",
        closeIcon: <ToastCrossIcon />,
      });
    }
  };

  const handleDeleteThread = async () => {
    setDisable(true);
    await deleteThread(
      selectedUser,
      channelMessages?.data,
      dispatch,
      onDelete,
      setOnDelete,
    );
    setDisable(false);
    setConfirmDeleteChatPopup(false);
  };

  const getSupportedAudioMimeType = () => {
    if (typeof MediaRecorder === "undefined") return "";
    if (MediaRecorder.isTypeSupported("audio/mp4")) return "audio/mp4";
    if (MediaRecorder.isTypeSupported("audio/webm;codecs=opus")) {
      return "audio/webm;codecs=opus";
    }
    if (MediaRecorder.isTypeSupported("audio/webm")) return "audio/webm";
    return "";
  };

  const stopWaveformMonitor = () => {
    if (waveformRafRef.current) {
      cancelAnimationFrame(waveformRafRef.current);
      waveformRafRef.current = null;
    }
    if (audioContextRef.current) {
      audioContextRef.current.close().catch(() => {});
      audioContextRef.current = null;
    }
    analyserRef.current = null;
  };

  const stopMediaTracks = () => {
    mediaStreamRef.current?.getTracks()?.forEach((track) => track.stop());
    mediaStreamRef.current = null;
  };

  const startWaveformMonitor = (stream) => {
    try {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return;
      const audioContext = new AudioCtx();
      const analyser = audioContext.createAnalyser();
      analyser.fftSize = 256;
      analyser.smoothingTimeConstant = 0.35;
      const source = audioContext.createMediaStreamSource(stream);
      source.connect(analyser);
      audioContextRef.current = audioContext;
      analyserRef.current = analyser;
      const data = new Uint8Array(analyser.fftSize);
      const history = Array(160).fill(0.12);

      const tick = () => {
        analyser.getByteTimeDomainData(data);
        let sum = 0;
        for (let i = 0; i < data.length; i++) {
          const deviation = (data[i] - 128) / 128;
          sum += deviation * deviation;
        }
        const rms = Math.sqrt(sum / data.length);
        const level = Math.min(1, Math.max(0.08, rms * 3.6));
        waveformAmplitudeRef.current = level;
        history.push(level);
        if (history.length > 160) history.shift();
        setWaveformBars([...history]);
        waveformRafRef.current = requestAnimationFrame(tick);
      };
      tick();
    } catch (e) {
      // Waveform is decorative; recording can continue without it.
    }
  };

  const startRecording = async () => {
    if (isRecording || voiceMemoPreview) return;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });
      mediaStreamRef.current = stream;
      const mimeType = getSupportedAudioMimeType();
      const media = mimeType
        ? new MediaRecorder(stream, { mimeType })
        : new MediaRecorder(stream);
      mediaRecorder.current = media;
      audioChunksRef.current = [];
      media.ondataavailable = (event) => {
        if (!event.data || event.data.size === 0) return;
        audioChunksRef.current.push(event.data);
      };
      media.start();
      setWaveformBars(Array(160).fill(0.12));
      startWaveformMonitor(stream);
      setIsRecording(true);
      setIsRunning(true);
      setTimer(0);
    } catch (e) {
      stopMediaTracks();
      setIsRecording(false);
      notification.error({
        description: "Microphone access is required to record a voice memo.",
        placement: "bottomRight",
        className: "createdNotification",
        closeIcon: <ToastCrossIcon />,
      });
    }
  };

  const discardVoiceMemo = () => {
    if (mediaRecorder.current && mediaRecorder.current.state !== "inactive") {
      try {
        mediaRecorder.current.onstop = null;
        mediaRecorder.current.stop();
      } catch (e) {
        // already stopped
      }
    }
    mediaRecorder.current = null;
    stopWaveformMonitor();
    stopMediaTracks();
    audioChunksRef.current = [];
    setIsRecording(false);
    setIsRunning(false);
    setTimer(0);
    setWaveformBars([]);
    waveformAmplitudeRef.current = 0.12;
    setVoiceMemoPreview(null);
  };

  const stopRecording = () => {
    if (!mediaRecorder.current || mediaRecorder.current.state === "inactive") {
      return;
    }
    const recordedSeconds = timer;
    const mimeType =
      mediaRecorder.current.mimeType ||
      getSupportedAudioMimeType() ||
      "audio/webm";
    mediaRecorder.current.onstop = () => {
      const audioBlob = new Blob(audioChunksRef.current, { type: mimeType });
      const file = blobToFile(audioBlob, mimeType);
      setVoiceMemoPreview({
        file,
        duration: Math.max(1, recordedSeconds),
        bars: waveformBars,
      });
      audioChunksRef.current = [];
      setIsRecording(false);
      setIsRunning(false);
      stopWaveformMonitor();
      stopMediaTracks();
    };
    mediaRecorder.current.stop();
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = (time % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };
  useEffect(() => {
    let interval;
    if (isRunning) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer + 1);
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [isRunning]);

  useEffect(() => {
    return () => {
      if (mediaRecorder.current && mediaRecorder.current.state !== "inactive") {
        try {
          mediaRecorder.current.onstop = null;
          mediaRecorder.current.stop();
        } catch (e) {
          // already stopped
        }
      }
      if (waveformRafRef.current) {
        cancelAnimationFrame(waveformRafRef.current);
      }
      mediaStreamRef.current?.getTracks()?.forEach((track) => track.stop());
      audioContextRef.current?.close?.().catch(() => {});
    };
  }, []);

  // Scroll to bottom synchronously (before paint) when new messages arrive at
  // the end while the user is already near the bottom. Using useLayoutEffect
  // here guarantees the scroll adjustment happens before the browser paints,
  // eliminating the single-frame "jump" when a day separator appears.
  useLayoutEffect(() => {
    if (!channelMessages?.data) return;
    const firstId = channelMessages?.data?.[0]?.thread_id || null;
    const isPrependRender =
      firstId &&
      lastKnownFirstThreadIdRef.current &&
      firstId !== lastKnownFirstThreadIdRef.current;
    lastKnownFirstThreadIdRef.current = firstId;
    if (isPrependRender) return;
    if (isUserNearBottomRef.current) {
      const container = messagesEndRef.current
        ? messagesEndRef.current.closest(".chat-messages")
        : null;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }
  }, [channelMessages?.data]);

  // Watch for DOM changes (like reactions being added) and scroll if user is near bottom
  useEffect(() => {
    const container = messagesEndRef.current
      ? messagesEndRef.current.closest(".chat-messages")
      : null;
    if (!container || !hasSelectedUser) return;

    let rafId = null;

    const mutationObserver = new MutationObserver(() => {
      // During a prepend operation the layout anchor handles positioning;
      // the MutationObserver must not interfere.
      if (anchorThreadIdRef.current) return;
      if (!isUserNearBottomRef.current) return;

      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        rafId = null;
        container.scrollTop = container.scrollHeight;
      });
    });

    mutationObserver.observe(container, {
      childList: true,
      subtree: true,
      attributes: false,
    });

    return () => {
      mutationObserver.disconnect();
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [hasSelectedUser, channelMessages?.data]);

  useEffect(() => {
    fetchChannelMessages();
  }, [fetchChannelMessages]);

  // Force scroll to bottom when chat changes
  useEffect(() => {
    if (!selectedUser?.chat_id) return;

    // Reset lazy-load anchor state so the "prepend render" heuristic in the
    // near-bottom auto-scroll effect / layout effect does not misfire on the
    // first message list we see for the newly selected chat.
    prevFirstThreadIdRef.current = null;
    anchorThreadIdRef.current = null;
    anchorOffsetFromTopRef.current = 0;
    lastKnownFirstThreadIdRef.current = null;

    // Reset scroll position to bottom immediately when switching chats
    const scrollToBottomNow = () => {
      const container = messagesEndRef.current
        ? messagesEndRef.current.closest(".chat-messages")
        : null;
      if (container && container.scrollHeight > 0) {
        container.scrollTop = container.scrollHeight;
      }
    };

    // Immediate attempt
    scrollToBottomNow();

    // Also try after a short delay to catch when DOM updates
    const timeout1 = setTimeout(scrollToBottomNow, 50);
    const timeout2 = setTimeout(scrollToBottomNow, 200);

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, [selectedUser?.chat_id]);

  // Also scroll to bottom when messages finish loading after chat switch
  useEffect(() => {
    if (
      selectedUser?.chat_id &&
      channelMessages?.data?.length > 0 &&
      !channelMessages?.isLoading
    ) {
      scrollToBottom();
    }
  }, [selectedUser?.chat_id, channelMessages?.isLoading, scrollToBottom]);

  useEffect(() => {
    inputRef?.current?.focus();
  }, [channelMessages?.isLoading]);
  const [isDragOver, setIsDragOver] = useState(false);

  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const newFiles = Array.from(event.target.files);
    const totalFiles = [...file, ...newFiles];

    if (totalFiles.length > 10) {
      toastMessage("warning", "Maximum 10 files are allowed!");
      return;
    }

    const { mediaCollection, individualFiles } = categorizeFiles(newFiles);

    if (mediaCollection.length > 0) {
      setSelectedMediaCollection(mediaCollection);
      setShowMediaPreview(true);
    } else {
      setFile(totalFiles);
    }

    scrollToBottom();
  };

  // Chat-specific drag and drop handlers
  const handleChatDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  };

  const handleChatDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Only set dragOver to false if we're leaving the chatHolder entirely
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsDragOver(false);
    }
  };

  const handleChatDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleChatDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);

    const droppedFiles = Array.from(e.dataTransfer.files);
    if (droppedFiles.length === 0) return;

    const currentFileCount =
      file.length + (selectedMediaCollection.length || 0);
    const totalFileCount = currentFileCount + droppedFiles.length;

    if (totalFileCount > 10) {
      toastMessage("warning", "Maximum 10 files are allowed!");
      return;
    }

    const totalFiles = [...file, ...droppedFiles];

    let filesToCategorize;
    if (showMediaPreview && selectedMediaCollection.length > 0) {
      filesToCategorize = [...selectedMediaCollection, ...droppedFiles];
    } else if (file.length > 0) {
      filesToCategorize = totalFiles;
    } else {
      filesToCategorize = droppedFiles;
    }

    const { mediaCollection, individualFiles } =
      categorizeFiles(filesToCategorize);

    if (mediaCollection.length > 0) {
      setFile([]);
      setSelectedMediaCollection(mediaCollection);
      setShowMediaPreview(true);

      // Add any non-media files to individual files list
      if (individualFiles.length > 0) {
        setFile(individualFiles);
      }
    } else {
      setSelectedMediaCollection([]);
      setShowMediaPreview(false);
      setFile(totalFiles);
    }
  };

  const handleRemoveFile = (index) => {
    let temp = [...file];
    temp.splice(index, 1);
    setFile(temp);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        // Click occurred outside of the picker, so close it
        setShowEmojiPicker(false);
      }
    }

    if (showEmojiPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showEmojiPicker]);

  useEffect(() => {
    const updateHeights = () => {
      const composerEl = composerRef.current;
      const height = composerEl ? composerEl.offsetHeight || 0 : 0;
      setComposerHeight(height);
      setListHeight(`calc(100vh - 152px - ${height}px)`);

      if (isUserNearBottomRef.current) {
        requestAnimationFrame(() => {
          scrollToBottom();
        });
      }
    };

    updateHeights();

    const composerEl = composerRef.current;
    if (composerEl && typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(() => updateHeights());
      observer.observe(composerEl);
      return () => observer.disconnect();
    }

    window.addEventListener("resize", updateHeights);
    return () => {
      window.removeEventListener("resize", updateHeights);
    };
  }, [hasSelectedUser, scrollToBottom]);

  useEffect(() => {
    const container = messagesEndRef.current
      ? messagesEndRef.current.closest(".chat-messages")
      : null;
    if (!container) return;

    const updateNearBottom = () => {
      const distance =
        container.scrollHeight - container.scrollTop - container.clientHeight;
      const threshold = Math.max(120, composerHeight + 24);
      isUserNearBottomRef.current = distance <= threshold;
    };

    updateNearBottom();
    container.addEventListener("scroll", updateNearBottom, { passive: true });
    return () => {
      container.removeEventListener("scroll", updateNearBottom);
    };
  }, [composerHeight, hasSelectedUser, channelMessages?.data?.length]);

  // Lazy-load older messages when the user scrolls near the top of the list.
  useEffect(() => {
    if (!hasSelectedUser) return;
    const container = messagesEndRef.current
      ? messagesEndRef.current.closest(".chat-messages")
      : null;
    if (!container) return;

    const onScroll = () => {
      const st = container.scrollTop;
      if (st > SCROLL_UP_THRESHOLD_PX) return;
      const { hasMore, isLoadingOlder, isLoading } =
        store.getState().chats.channelMessages;
      if (!hasMore || isLoadingOlder || isLoading) return;
      // Capture an element-based anchor: record the topmost visible message
      // and its pixel offset from the viewport top. After the prepend lands,
      // the layout effect will re-find this element by thread_id and restore
      // the exact same offset, so the user's view does not shift.
      const anchorEl = findTopmostVisibleMessage(container);
      if (anchorEl) {
        anchorThreadIdRef.current = anchorEl.getAttribute("data-thread-id");
        anchorOffsetFromTopRef.current =
          anchorEl.getBoundingClientRect().top -
          container.getBoundingClientRect().top;
      } else {
        anchorThreadIdRef.current = null;
        anchorOffsetFromTopRef.current = 0;
      }
      loadOlderMessages(selectedUser, dispatch, store.getState);
    };

    container.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      container.removeEventListener("scroll", onScroll);
    };
  }, [hasSelectedUser, selectedUser, dispatch, channelMessages?.data?.length]);

  // Preserve scroll anchor when older messages are prepended. We re-find the
  // captured anchor element (recorded by the scroll-up listener) in the
  // freshly rendered DOM and restore its exact offset from the viewport top.
  // This is immune to scrollHeight changes caused by images/reactions loading.
  useLayoutEffect(() => {
    const firstId = channelMessages?.data?.[0]?.thread_id || null;
    const prevFirstId = prevFirstThreadIdRef.current;
    if (!firstId || firstId === prevFirstId) {
      if (firstId) prevFirstThreadIdRef.current = firstId;
      return;
    }
    prevFirstThreadIdRef.current = firstId;
    const anchorThreadId = anchorThreadIdRef.current;
    anchorThreadIdRef.current = null;
    if (!anchorThreadId) return;
    const container = messagesEndRef.current
      ? messagesEndRef.current.closest(".chat-messages")
      : null;
    if (!container) return;
    const anchorEl = container.querySelector(
      `[data-thread-id="${CSS.escape(anchorThreadId)}"]`,
    );
    if (!anchorEl) return;
    const targetOffset = anchorOffsetFromTopRef.current;
    const currentOffset =
      anchorEl.getBoundingClientRect().top -
      container.getBoundingClientRect().top;
    const diff = currentOffset - targetOffset;
    if (diff !== 0) {
      container.scrollTop = container.scrollTop + diff;
    }
  }, [channelMessages?.data]);

  const userName = useMemo(() => {
    if (!hasSelectedUser) return "";
    if (selectedUser?.is_group_chat) {
      return selectedUser?.name ?? "";
    }
    const profile = selectedUser?.receiver_profile?.[0];
    return isChatUserDeleted(profile, allUsers?.data ?? [])
      ? "DELETED USER"
      : (profile?.name ?? "");
  }, [hasSelectedUser, selectedUser, allUsers]);

  const headerMenuItems = useMemo(
    () =>
      actionMenu(
        selectedUser,
        setConfirmDeleteChatPopup,
        channelMessages,
        authUser?.id,
        handleStarToggle,
      ),
    [
      selectedUser,
      setConfirmDeleteChatPopup,
      channelMessages,
      authUser?.id,
      handleStarToggle,
    ],
  );

  const composerProps = {
    message,
    handleInputChange,
    handleKeyPress,
    handleKeyDown,
    inputRef,
    overlayTextMetrics,
    inputHighlightHtml,
    showMediaPreview,
    selectedMediaCollection,
    handleRemoveFromCollection,
    file,
    handleRemoveFile,
    disableSendChatBtn,
    handleSendMessage,
    isRecording,
    voiceMemoPreview,
    waveformBars,
    waveformAmplitudeRef,
    timer,
    formatTime,
    startRecording,
    stopRecording,
    discardVoiceMemo,
    isInputFocused,
    setIsInputFocused,
    editingMessage,
    handleCancelEdit,
    replyingToMessage,
    handleCancelReply,
    replyAuthorName: (() => {
      if (!replyingToMessage) return null;
      if (replyingToMessage.sender_id == authUser?.id) return "You";
      const data = returnUserDataInGroupChat({
        sender_id: replyingToMessage.sender_id,
      });
      return data?.name || "User";
    })(),
    showEmojiPicker,
    setShowEmojiPicker,
    pickerRef,
    handleEmojiClick,
    handleIconClick,
    handleFileChange,
    mentionOpen,
    filteredMentions,
    mentionIndex,
    insertMention,
    setMentionIndex,
    handleInsertAtShortcut,
    fileInputRef,
    onPreviewAttachment: handleClickImage,
  };

  return (
    <>
      <div className="chat-window chat-window-v2">
        <ChatHeaderSection
          newChat={props?.newChat}
          setNewChat={props?.setNewChat}
          selectedUser={selectedUser}
          allUsers={allUsers}
          authUser={authUser}
          currentUserId={me?.data?.id ?? authUser?.id}
          menuItems={headerMenuItems}
          handleMembersUpdate={handleMembersUpdate}
          currentSalonId={currentSalonId}
        />
        <div className="chat-window-v2__content">
          {hasSelectedUser && (
            <>
              <MessagesPanel
                selectedUser={selectedUser}
                channelMessages={channelMessages}
                renderItem={renderMessageItem}
                showMediaPreview={showMediaPreview}
                hasAttachments={file.length > 0}
                isDragOver={isDragOver}
                onDragEnter={handleChatDragEnter}
                onDragLeave={handleChatDragLeave}
                onDragOver={handleChatDragOver}
                onDrop={handleChatDrop}
                listHeight={listHeight}
              />
              <ChatComposerSection
                selectedUser={selectedUser}
                userName={userName}
                composer={composerProps}
                ref={composerRef}
              />
            </>
          )}
        </div>
      </div>

      <DeleteModal
        show={confirmDeleteChatPopup}
        onHide={() => setConfirmDeleteChatPopup(false)}
        heading="Delete Chat?"
        handleDelete={handleDeleteThread}
        disable={disable}
        para={<>Are you sure you want to delete chat</>}
        notificationMessage="Event"
      />

      <Modal
        className="chatPreviewModal"
        open={isOpenPreview}
        onCancel={handleCancelPreview}
        footer={null}
        centered
      >
        <img src={srcPreview} alt="" className="chatPreviewImage" />
      </Modal>

      <ReactionUserList
        visible={showReactionUsers}
        onClose={() => setShowReactionUsers(false)}
        emoji={reactionUsersData.emoji}
        users={reactionUsersData.users}
        messageId={reactionUsersData.messageId}
      />

      <SeenByModal
        visible={showSeenByModal}
        onClose={() => setShowSeenByModal(false)}
        message={seenByMessage}
        seenMembers={
          seenByMessage ? calculateSeenMembers(seenByMessage, selectedUser) : []
        }
      />
    </>
  );
};

const ChatHeaderSection = ({
  newChat,
  setNewChat,
  selectedUser,
  allUsers,
  authUser,
  currentUserId,
  menuItems,
  handleMembersUpdate,
  currentSalonId,
}) => {
  if (newChat) {
    return (
      <div className="chat-header">
        <div className="titleBox d-flex align-items-center justify-content-between w-100">
          <NewChat setNewChat={setNewChat} />
        </div>
      </div>
    );
  }

  if (!selectedUser || Object.keys(selectedUser).length === 0) {
    return <div className="chat-header" />;
  }

  const isGroupChat = selectedUser?.is_group_chat;
  const profile = selectedUser?.receiver_profile?.[0];
  const isDeleted =
    !isGroupChat && isChatUserDeleted(profile, allUsers?.data ?? []);
  const displayName = isGroupChat
    ? personalizeGroupNameForReceiver(
        selectedUser?.name ?? "",
        authUser?.name ?? "",
      )
    : profile?.name;

  let avatarSrc = null;
  if (isGroupChat) {
    // Check if thumbnail is a valid URL
    const hasValidThumbnail = isValidUrl(selectedUser?.thumbnail);
    // Check if image is a valid URL
    const hasValidImage = isValidUrl(selectedUser?.image);

    avatarSrc = hasValidThumbnail
      ? selectedUser.thumbnail
      : hasValidImage
        ? selectedUser.image
        : EveryOneImage;
  } else {
    avatarSrc = isDeleted ? null : (profile?.thumbnail ?? profile?.image);
  }
  // const avatarSrc = isGroupChat
  //   ? selectedUser?.image
  //     ? profile?.image
  //     : EveryOneImage
  //   : isDeleted
  //     ? null
  //     : profile?.image;

  return (
    <div className="chat-header">
      <div className="titleBox d-flex align-items-center justify-content-between w-100">
        <div className="d-flex align-items-center">
          <AvatarImage
            name={displayName}
            src={avatarSrc}
            placeholder={Assets.ProfilePlaceholder}
            size={40}
          />
          <h3
            className="ms-3 m-0"
            style={{
              fontSize: "22px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "calc(100vw - 1000px)",
            }}
          >
            {displayName}
          </h3>
        </div>

        <div className="d-flex align-items-center">
          {isGroupChat && (
            <div className="group-member-info">
              <span className="group-member-count">
                {getActiveMemberCount(
                  selectedUser,
                  currentUserId ?? authUser?.id,
                  currentSalonId,
                )}{" "}
                Members
              </span>
              <span className="member-separator">•</span>
              <AddPeopleSelector
                selectedUser={selectedUser}
                onMembersUpdate={handleMembersUpdate}
              />
            </div>
          )}

          <Dropdown
            menu={{ items: menuItems }}
            placement="bottomRight"
            trigger={["click"]}
            overlayClassName={"defaultDropdown chatDropdown"}
          >
            <div className="icon cursor-pointer">
              <MoreIcon />
            </div>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

const MessagesPanel = ({
  selectedUser,
  channelMessages,
  renderItem,
  showMediaPreview,
  hasAttachments,
  isDragOver,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
  listHeight,
}) => {
  return (
    <div
      className={`chatHolder chat-window-v2__holder ${isDragOver ? "drag-over" : ""}`}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      <div
        className={`chat-messages ${showMediaPreview ? "with-media-preview" : ""} ${hasAttachments ? "with-file" : ""}`}
        style={{
          overflow: "auto",
          height: listHeight,
        }}
      >
        {channelMessages?.isLoading ? (
          Object.keys(selectedUser || {})?.length > 0 && (
            <LoadingScreen child={true} />
          )
        ) : (
          <>
            {channelMessages?.isLoadingOlder && (
              <div
                className="chat-messages__loading-older"
                style={{
                  height: 0,
                  position: "relative",
                  overflow: "visible",
                  pointerEvents: "none",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 8,
                    left: 0,
                    right: 0,
                    display: "flex",
                    justifyContent: "center",
                    zIndex: 1,
                  }}
                >
                  <Spin size="small" />
                </div>
              </div>
            )}
            <List
              dataSource={channelMessages?.data || []}
              renderItem={renderItem}
              rowKey={(item) => item?.thread_id || item?.id || item?.created_at}
              className="chat-winddow__messages-list"
              style={{ height: listHeight }}
            />
          </>
        )}
      </div>
    </div>
  );
};

const MentionSuggestions = ({
  visible,
  suggestions,
  activeIndex,
  onSelect,
  onHover,
}) => {
  if (!visible) return null;

  return (
    <div
      className="mention-suggestions above-input"
      style={{
        position: "absolute",
        bottom: "calc(100% + 18px)",
        left: "-15px",
        right: 0,
        background: "#fff",
        border: "1px solid #eee",
        borderRadius: 8,
        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        zIndex: 20,
        maxHeight: 240,
        maxWidth: 320,
        overflow: "auto",
        paddingTop: 6,
        paddingBottom: 6,
      }}
    >
      <List
        size="small"
        dataSource={suggestions}
        locale={{ emptyText: "No matches" }}
        renderItem={(item, idx) => {
          const { id, name, image, isGroup } = item;
          return (
            <List.Item
              key={id}
              className={`mention-suggestion-item cursor-pointer ${idx === activeIndex ? "active" : ""}`}
              onMouseDown={(e) => {
                e.preventDefault();
                onSelect(id, name);
              }}
              onMouseEnter={() => onHover(idx)}
            >
              <div className="d-flex align-items-center" style={{ gap: 8 }}>
                <Avatar
                  size={40}
                  src={!isGroup && image ? image : undefined}
                  style={{ backgroundColor: "#f0f0f0" }}
                >
                  {!image || isGroup ? (
                    <img
                      src={isGroup ? EveryOneImage : Assets.ProfilePlaceholder}
                      alt="avatar"
                      style={{
                        width: 35,
                        height: 35,
                        borderRadius: "50%",
                      }}
                    />
                  ) : null}
                </Avatar>
                <span>{name}</span>
              </div>
            </List.Item>
          );
        }}
      />
    </div>
  );
};

const ChatComposerSection = React.forwardRef(
  ({ selectedUser, userName, composer }, ref) => {
    if (!selectedUser || Object.keys(selectedUser).length === 0) {
      return null;
    }

    const {
      message,
      handleInputChange,
      handleKeyPress,
      handleKeyDown,
      inputRef,
      overlayTextMetrics,
      inputHighlightHtml,
      showMediaPreview,
      selectedMediaCollection,
      handleRemoveFromCollection,
      file,
      handleRemoveFile,
      disableSendChatBtn,
      handleSendMessage,
      isRecording,
      voiceMemoPreview,
      waveformBars,
      waveformAmplitudeRef,
      timer,
      formatTime,
      startRecording,
      stopRecording,
      discardVoiceMemo,
      isInputFocused,
      setIsInputFocused,
      editingMessage,
      handleCancelEdit,
      replyingToMessage,
      handleCancelReply,
      replyAuthorName,
      showEmojiPicker,
      setShowEmojiPicker,
      pickerRef,
      handleEmojiClick,
      handleIconClick,
      handleFileChange,
      mentionOpen,
      filteredMentions,
      mentionIndex,
      insertMention,
      setMentionIndex,
      handleInsertAtShortcut,
      fileInputRef,
      onPreviewAttachment,
    } = composer;

    const replyMediaLabel = (() => {
      if (!replyingToMessage) return null;
      if (replyingToMessage.message_type == message_type?.image) return "Photo";
      if (replyingToMessage.message_type == message_type?.video) return "Video";
      if (replyingToMessage.message_type == message_type?.gif) return "GIF";
      if (replyingToMessage.message_type == message_type?.pdf)
        return "Document";
      if (replyingToMessage.message_type == message_type?.media)
        return "Document";
      if (replyingToMessage.message_type == message_type?.media_collection)
        return "Media";
      if (replyingToMessage.message_type == message_type?.audio) return "Audio";
      if (replyingToMessage.message_type == message_type?.voice_memo)
        return "Voice Memo";
      return null;
    })();
    const replyPreviewSnippet = replyingToMessage
      ? replyMediaLabel ||
        (replyingToMessage.text && replyingToMessage.text.trim().length > 0
          ? replyingToMessage.text
          : "Message")
      : "";

    const sendButtonClass = getChatSendButtonClass({
      message,
      files: file,
      mediaCollection: selectedMediaCollection,
    });
    const isVoiceMemoActive = isRecording || !!voiceMemoPreview;
    const showMic = !isVoiceMemoActive && !editingMessage;
    const voiceTime = isRecording ? timer : voiceMemoPreview?.duration || 0;
    const waveRef = useRef(null);
    const [barCount, setBarCount] = useState(120);

    useEffect(() => {
      if (!isVoiceMemoActive) return;
      const el = waveRef.current;
      if (!el) return;
      const updateCount = () => {
        setBarCount(Math.max(80, Math.floor(el.clientWidth / 6)));
      };
      updateCount();
      const observer = new ResizeObserver(updateCount);
      observer.observe(el);
      return () => observer.disconnect();
    }, [isVoiceMemoActive]);

    const sourceBars = waveformBars.length
      ? waveformBars
      : Array(barCount).fill(0.18);
    const displayBars = Array.from({ length: barCount }, (_, index) => {
      if (sourceBars.length >= barCount) {
        return sourceBars[sourceBars.length - barCount + index];
      }
      return sourceBars[index] ?? 0.18;
    });

    return (
      <div className="chat-window-v2__composer" ref={ref}>
        <div
          className={`chat-window-input align-items-center w-100 ${showMediaPreview ? "with-inline-media-preview" : ""} ${isVoiceMemoActive ? "voice-memo-active" : ""}`}
          style={{
            overflow: "initial",
            position: "relative",
          }}
        >
          {isVoiceMemoActive && (
            <div className="voice-memo-composer">
              <button
                type="button"
                className="voice-memo-composer__cancel"
                onClick={discardVoiceMemo}
                aria-label="Cancel voice memo"
              >
                ✕
              </button>
              <div
                className="voice-memo-composer__wave"
                ref={waveRef}
                aria-hidden="true"
              >
                {displayBars.map((level, index) => (
                  <span
                    key={index}
                    className="voice-memo-composer__bar"
                    style={{
                      height: `${Math.round(8 + level * 34)}px`,
                    }}
                  />
                ))}
              </div>
              <span className="voice-memo-composer__time">
                {isRecording ? "Listening" : formatTime(voiceTime)}
              </span>
              {isRecording ? (
                <button
                  type="button"
                  className="voice-memo-composer__action"
                  onClick={stopRecording}
                  aria-label="Stop recording"
                >
                  <img
                    src={Assets.VoiceMemoCheck}
                    alt=""
                    className="voice-memo-composer__check-icon"
                  />
                </button>
              ) : (
                <Button
                  onClick={handleSendMessage}
                  type="primary"
                  disabled={disableSendChatBtn}
                  className="chatSend isInput voice-memo-composer__send"
                >
                  {disableSendChatBtn ? (
                    <div className="load black" />
                  ) : (
                    <SendButtonTriangle />
                  )}
                </Button>
              )}
            </div>
          )}
          <div
            className="messageBox position-relative"
            style={{ visibility: isVoiceMemoActive ? "hidden" : undefined }}
          >
            {replyingToMessage && (
              <div className="reply-preview-bar">
                <span className="reply-preview-bar__icon">
                  <ReplyIcon width={18} height={14} color="#6f42c1" />
                </span>
                <div className="reply-preview-bar__body">
                  <div className="reply-preview-bar__author">
                    Replying to {replyAuthorName}
                  </div>
                  <div className="reply-preview-bar__snippet">
                    {replyPreviewSnippet}
                  </div>
                </div>
                <button
                  type="button"
                  className="reply-preview-bar__close"
                  onClick={handleCancelReply}
                  aria-label="Cancel reply"
                  title="Cancel reply"
                >
                  ✕
                </button>
              </div>
            )}
            {showMediaPreview && (
              <div className="inline-media-preview">
                <MediaCollectionPreview
                  selectedFiles={selectedMediaCollection}
                  onRemoveFile={handleRemoveFromCollection}
                  inline={true}
                />
              </div>
            )}

            {file?.length > 0 && (
              <div className="attachment-wrapper d-block">
                {file.map((item, index) => (
                  <div key={index} className="file-box mt-2">
                    <div className="d-flex align-items-center justify-content-between">
                      {item.type && item.type.startsWith("image/") ? (
                        <div className="file-preview-container d-flex align-items-center">
                          <img
                            src={URL.createObjectURL(item)}
                            alt={item.name}
                            className="file-preview-image"
                            onClick={() =>
                              onPreviewAttachment(URL.createObjectURL(item))
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <span className="file-name ms-2">{item?.name}</span>
                        </div>
                      ) : (
                        <span className="file-name">{item?.name}</span>
                      )}
                      {!disableSendChatBtn && (
                        <span
                          onClick={() => handleRemoveFile(index)}
                          style={{ cursor: "pointer" }}
                        >
                          <FaTimes />
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div
              className="message-field-overlay-wrapper"
              style={{
                position: "relative",
                maxHeight: "200px",
                overflow: "auto",
                visibility: isVoiceMemoActive ? "hidden" : undefined,
              }}
            >
              <div
                className="message-field-highlights"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  padding: overlayTextMetrics.padding,
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  color: "#000",
                  pointerEvents: "none",
                  fontSize: overlayTextMetrics.fontSize,
                  fontFamily: overlayTextMetrics.fontFamily,
                  fontWeight: overlayTextMetrics.fontWeight,
                  lineHeight: overlayTextMetrics.lineHeight,
                  letterSpacing: overlayTextMetrics.letterSpacing,
                }}
                dangerouslySetInnerHTML={{ __html: inputHighlightHtml }}
              />
              <TextArea
                id={"message-field"}
                ref={inputRef}
                value={message}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                onKeyDown={handleKeyDown}
                onFocus={() => setIsInputFocused(true)}
                onBlur={() => setIsInputFocused(false)}
                placeholder={`Message ${userName}...`}
                className={`message-field ${showMediaPreview ? "with-inline-media" : ""} placeholder-custom`}
                autoSize={true}
                // disabled={file ? true : false}
                style={{
                  background: "transparent",
                  position: "relative",
                  color: "transparent",
                  caretColor: "#000",
                  fontSize: overlayTextMetrics.fontSize,
                  fontFamily: overlayTextMetrics.fontFamily,
                  fontWeight: overlayTextMetrics.fontWeight,
                  lineHeight: overlayTextMetrics.lineHeight,
                  letterSpacing: overlayTextMetrics.letterSpacing,
                  padding: overlayTextMetrics.padding,
                }}
              />
            </div>

            <MentionSuggestions
              visible={mentionOpen}
              suggestions={filteredMentions}
              activeIndex={mentionIndex}
              onSelect={(id, name) => insertMention(id, name)}
              onHover={setMentionIndex}
            />
          </div>

          <div
            className="chat-window-input--button-group"
            style={{ visibility: isVoiceMemoActive ? "hidden" : undefined }}
          >
            <div className="chat-window-input--button-group__emoji-file">
              <div
                className="upload-box-wrapper d-flex align-items-center"
                style={{ gap: "5px" }}
              >
                <div className="attachment-picker-wrapper flex">
                  <div className="chatInput">
                    <Button
                      type="link"
                      className="chatInput-icon"
                      onClick={handleIconClick}
                      icon={<CirclePlusIcon width={24} fill={"C#FCFCF"} />}
                    />
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      multiple
                    />
                  </div>
                </div>

                <div className="emoji-picker-wrapper wrapper-main-chat-emoji-picker">
                  <Button
                    type="link"
                    icon={<FaceSmileyIcon fill="red" width={20} />}
                    onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                    className="chatInput-icon"
                  />

                  {showEmojiPicker && (
                    <div className="picker" ref={pickerRef}>
                      <Picker onEmojiClick={handleEmojiClick} />
                    </div>
                  )}
                </div>

                <div className="flex emoji-picker-wrapper">
                  <Button
                    type="link"
                    icon={<AtRegularIcon width={20} />}
                    onClick={handleInsertAtShortcut}
                    className="chatInput-icon"
                  />
                </div>
              </div>
            </div>

            <div
              className="chat-window-input--button-group__send-recording"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              {editingMessage && (
                <Button
                  onClick={handleCancelEdit}
                  style={{
                    background: "#dc3545",
                    border: "none",
                    borderRadius: "50%",
                    width: "32px",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    marginRight: "8px",
                    color: "white",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                  title="Cancel editing"
                >
                  ✕
                </Button>
              )}
              {showMic && (
                <button
                  type="button"
                  className="voice-memo-mic-btn"
                  onClick={startRecording}
                  aria-label="Record voice memo"
                >
                  <img
                    src={Assets.VoiceMemoMic}
                    alt=""
                    className="voice-memo-mic-btn__icon"
                  />
                </button>
              )}
              <Button
                onClick={handleSendMessage}
                type="primary"
                disabled={disableSendChatBtn}
                className={sendButtonClass}
              >
                {disableSendChatBtn && <div className="load black" />}
                {!disableSendChatBtn && <SendButtonTriangle />}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  },
);

ChatComposerSection.displayName = "ChatComposerSection";

export default ChatWindowV2;
